"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IComponentSpiceModelDefinitionSchema = exports.IComponentSpiceModelDefinitionModelSchema = exports.IComponentSpiceModelDefinitionSubcircuitSchema = exports.IComponentSigmaModelSignalMapItemSchema = exports.IComponentSpiceModelSignalMapItemSchema = exports.IComponentSpiceModelDefinitionBaseSchema = void 0;
const zod_1 = require("zod");
const ComponentModelParameterDefinition_1 = require("../ComponentModelParameterDefinition");
const SpiceModelTests_1 = require("./SpiceModelTests");
const ISubModelSignalMapItemBase_1 = require("../ISubModelSignalMapItemBase");
const IModelInfoBase_1 = require("../DesignModels/IModelInfoBase");
const SignalId_1 = require("../DesignModels/SignalId");
exports.IComponentSpiceModelDefinitionBaseSchema = zod_1.z.object({
    modelName: zod_1.z.string(),
    modelPath: zod_1.z.string().optional(),
    modelType: zod_1.z.enum(['subcircuit', 'model']),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.any()).optional(),
});
exports.IComponentSpiceModelSignalMapItemSchema = ISubModelSignalMapItemBase_1.ISubModelSignalMapItemBaseSchema.extend({
    modelSignalId: SignalId_1.SignalIdSchema.optional(),
    modeId: zod_1.z.string().optional(),
    internalNet: zod_1.z.string().optional(),
    paramNo: zod_1.z.number(),
});
exports.IComponentSigmaModelSignalMapItemSchema = ISubModelSignalMapItemBase_1.ISubModelSignalMapItemBaseSchema.extend({
    modelSignalId: SignalId_1.SignalIdSchema,
    componentSignalId: SignalId_1.SignalIdSchema,
});
exports.IComponentSpiceModelDefinitionSubcircuitSchema = exports.IComponentSpiceModelDefinitionBaseSchema.merge((0, IModelInfoBase_1.IModelInfoBaseSchema)(exports.IComponentSpiceModelSignalMapItemSchema)).extend({
    modelType: zod_1.z.literal('subcircuit'),
    parameters: ComponentModelParameterDefinition_1.ComponentModelParameterDefinitionSchema.array().optional(),
    subcircuitName: zod_1.z.string().optional(),
    tests: SpiceModelTests_1.ISpiceModelTestSchema.array().optional(),
});
exports.IComponentSpiceModelDefinitionModelSchema = exports.IComponentSpiceModelDefinitionBaseSchema.extend({
    modelName: zod_1.z.string(),
    model: zod_1.z.string(),
    modelType: zod_1.z.literal('model'),
});
exports.IComponentSpiceModelDefinitionSchema = zod_1.z.discriminatedUnion('modelType', [
    exports.IComponentSpiceModelDefinitionSubcircuitSchema,
    exports.IComponentSpiceModelDefinitionModelSchema,
]);
//# sourceMappingURL=ComponentSpiceModelDefinition.js.map